import { apiClient } from "./client";
import type {
  ComponentListResponse,
  ComponentRecord,
  ComponentType,
  DispatchExtractionResponse,
  ExtractionRecord,
} from "../types/components";

export async function listGlobalComponents(params?: {
  type?: ComponentType;
  manufacturer?: string;
  q?: string;
  linked?: boolean;
  limit?: number;
  offset?: number;
}): Promise<ComponentListResponse> {
  const r = await apiClient.get<ComponentListResponse>("/api/components", {
    params,
  });
  return r.data;
}

export async function getComponent(id: string): Promise<ComponentRecord> {
  const r = await apiClient.get<ComponentRecord>(`/api/components/${id}`);
  return r.data;
}

export async function listProjectComponents(
  projectId: string,
  type?: ComponentType,
): Promise<ComponentRecord[]> {
  const r = await apiClient.get<ComponentRecord[]>(
    `/api/projects/${projectId}/components`,
    { params: type ? { type } : undefined },
  );
  return r.data;
}

export async function linkComponent(
  projectId: string,
  componentId: string,
): Promise<void> {
  await apiClient.post(
    `/api/projects/${projectId}/components/${componentId}/link`,
  );
}

export async function unlinkComponent(
  projectId: string,
  componentId: string,
): Promise<void> {
  await apiClient.delete(
    `/api/projects/${projectId}/components/${componentId}/link`,
  );
}

export async function dispatchExtraction(
  projectId: string,
  layerId: string,
): Promise<DispatchExtractionResponse> {
  const r = await apiClient.post<DispatchExtractionResponse>(
    `/api/projects/${projectId}/files/${layerId}/extract-component`,
  );
  return r.data;
}

export async function getExtraction(
  extractionId: string,
): Promise<ExtractionRecord> {
  const r = await apiClient.get<ExtractionRecord>(
    `/api/extractions/${extractionId}`,
  );
  return r.data;
}

export async function confirmExtraction(
  extractionId: string,
): Promise<ExtractionRecord> {
  const r = await apiClient.post<ExtractionRecord>(
    `/api/extractions/${extractionId}/confirm`,
  );
  return r.data;
}
